import React from 'react';
import PropTypes from 'prop-types';

const DataViz = ({
  renderMethod
}) => {
  const onMount = ({ element, selector }) => renderMethod({ element, selector });
  const selector = '.vra-dataviz__svg-container';
  return (
    <section
      className='vra-dataviz'
      ref={ (element) => { if (element) { onMount({ element, selector }); } } }>
      <svg className={selector.substr(1)} />
    </section>
  );
};

DataViz.propTypes = {
  renderMethod: PropTypes.func.isRequired
};

export default DataViz;
